import { env } from '../config/config';
import { PRO } from '../config/env';
import { useEffect, useState } from 'react';

export const validateEmail = (email) => {
  var re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

export const validateMobile = (mobile) => {
  let re = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
  return re.test(mobile) && mobile.length >= 8;
};

export const validateInteger = (str) => {
  return /^\d+$/.test(str);
};

export const validateFloat = (str) => {
  return /[+-]?([0-9]*[.])?[0-9]+/.test(str);
};

export const validateDecimal = (str, digit) => {
  if (digit == 1) {
    return /^[0-9]\d*(((,\d{3}){1})?(\.\d{0,1})?)$/.test(str); //小數後1位
  }
  return /^[0-9]\d*(((,\d{3}){1})?(\.\d{0,2})?)$/.test(str); //小數後2位
};

export const validateUnsignedFloat  = (str) => {
    //including 1.1, 0.345, .1, .0, .012345
    return /^(0|[1-9]\d*)?(\.\d+)?(?<=\d)$/.test(str);
};

export const jsonToQueryStr = (params) => {
  return Object.keys(params)
    .map((key) => {
      return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    })
    .join('&');
};

export const POST = 'POST';

export const GET = 'GET';

export const PUT = 'PUT';

export const DELETE = 'DELETE';

export const getMethodCRUD = (act) => {
  if (act == 'add') return POST;
  if (act == 'update') return PUT;
  if (act == 'delete') return DELETE;
  return GET;
};

export const getPathCRUD = (act, id) => {
  if (act == 'add') return '/add';
  if (act == 'update') return '/' + id;
  if (act == 'delete') return '/' + id;
  return '';
};

export const getBodyCRUD = (act, data) => {
  if (act == 'add') return { ...data };
  if (act == 'update') return { ...data };
  if (act == 'delete') return null;
  return {};
};

export const simplesleep = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

export const isEmptyObj = (obj) => {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
};

export const isObj = (obj) => {
  return obj !== null && typeof obj === 'object';
};

export const isArray = (arr) => {
  return Array.isArray(arr);
};

export const isEng = (str) => {
  let regex = new RegExp('[^\u0000-\u007F]+'); //use Unicode to match non-English characters
  return str && str != '' && !str.match(regex);
};

export const compareJson = (json1, json2) => {
  return JSON.stringify(json1) === JSON.stringify(json2);
};

export const copyJson = (obj) => {
  return JSON.parse(JSON.stringify(obj || {}));
};

export const compareArray = (arr1, arr2) => {
  if (!arr1 || !arr2) return false;

  if (arr1.length != arr2.length) return false;

  for (let i = 0, l = arr1.length; i < l; i++) {
    // Check if we have nested arrays
    if (arr1[i] instanceof Array && arr2[i] instanceof Array) {
      // recurse into the nested arrays
      if (!compareArray(arr1[i], arr2[i])) return false;
    } else if (arr1[i] != arr2[i]) {
      // Warning - two different object instances will never be equal: {x:20} != {x:20}
      return false;
    }
  }
  return true;
};

export const __DEV__ = env != PRO;

export const useWindowSize = () => {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });
  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    // Add event listener
    window.addEventListener('resize', handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []); // Empty array ensures that effect is only run on mount
  return windowSize;
};

export const simpleTriggerDownload = ({ file, filename }) => {
  // If you want to download file automatically using link attribute.
  const url = URL.createObjectURL(new Blob([file]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', (filename ?? 'excel') + '.xlsx');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const now = () => new Date();

export const stringDateTimeDbToDate = (dateString) => {
  dateString = dateString.toString();

  let year = dateString.substring(0, 4);
  let month = dateString.substring(4, 6);
  let day = dateString.substring(6, 8);

  let hh = dateString.substring(8, 10);
  let mm = dateString.substring(10, 12);
  let ss = dateString.substring(12, 14);

  let tmp_day = new Date(year, month / 1, 0);
  let tmp_date = tmp_day.getDate();
  if (day / 1 > tmp_date) {
    day = parseInt(tmp_date);
  }

  let date = new Date(year, month - 1, day, hh, mm, ss, 0);

  return !isNaN(date) ? date : null;
};

export const leftPad = (num, size) => {
  let s = num + '';
  while (s.length < size) s = '0' + s;
  return s;
};

export const monthBeforeFirstDay = (shift_month) => {
  const date = new Date();
  date.setMonth(date.getMonth() - (shift_month || 0), 1);
  return new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0);
};

export const monthAfterLastDay = (shift_month) => {
  const date = new Date();
  date.setMonth(date.getMonth() + (shift_month || 0) + 1, 1);
  return new Date(date.getFullYear(), date.getMonth(), 0, 23, 59, 59, 0);
};
